var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('landing-layout',[_c('b-row',{staticClass:"center-aligning-row"},[_c('b-col',{attrs:{"cols":"12","md":"8","lg":"5"}},[_c('h2',[_vm._v(_vm._s(_vm.$t("loginForm.sectionTitle")))]),_c('login-form')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }